var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"title",class:{green_background:_vm.greenBackground}},[_c('p',[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"video"},[_c('iframe',{attrs:{"src":_vm.link,"frameborder":"0","allowfullscreen":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }